import { render, staticRenderFns } from "./ConfirmPerson.vue?vue&type=template&id=6b62be37&scoped=true&"
import script from "./ConfirmPerson.vue?vue&type=script&lang=js&"
export * from "./ConfirmPerson.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPerson.vue?vue&type=style&index=0&id=6b62be37&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b62be37",
  null
  
)

export default component.exports